import CommonSwitch from "./CommonSwitch";
export default CommonSwitch;
